export enum EnvironmentNames {
  Localhost = 'localhost',
  LocalhostBE = 'localhost-be',
  Dev = 'dev',
  Staging = 'staging',
  Prod = 'prod',
  Fairfax = 'fairfax'
}
